import React, { ReactNode } from 'react';

import { DropdownEntry } from '~/components/dropdown-menu/dropdown-group/DropdownGroup';

import { NavItem } from '../nav-item/NavItem';
import * as S from './HeaderCategoryGroup.styles';

export type UnreadConversationType = {
  id: string;
  name: string;
  status?: string | null;
  tasks?: Array<{
    input?: string;
  }>;
};

export interface HeaderCategoryItem {
  label?: ReactNode;
  key: string;
  icon?: ReactNode;
  onClick: (item: HeaderCategoryItem) => void;
  dropdownItems?: DropdownEntry[][];
  pillStyle?: boolean;
  isAlfred?: boolean;
  showTooltip?: boolean;
  notification?: ReactNode;
  isProcessing?: boolean;
  isFinished?: boolean;
  isDashboardUpdatesEnabled?: boolean;
  unreadConversations?: UnreadConversationType[];
  onConversationClick?: (conversationId: string) => void;
}

export interface HeaderCategory {
  id?: string;
  title?: string;
  items: HeaderCategoryItem[];
}

interface HeaderCategoryGroupProps {
  activeKey?: string;
  active?: boolean;
  category: HeaderCategory;
  disabledKeys?: string[];
}

export const HeaderCategoryGroup = ({
  activeKey,
  category,
  disabledKeys,
}: HeaderCategoryGroupProps) => {
  return (
    <S.HeaderCategoryGroupRoot>
      {category.title && (
        <S.HeaderCategoryTitle>{category.title}</S.HeaderCategoryTitle>
      )}
      <S.HeaderItems>
        {category.items.map(item => {
          return (
            <NavItem
              key={item.key}
              item={item}
              activeKey={activeKey}
              disabled={disabledKeys?.includes(item.key)}
            />
          );
        })}
      </S.HeaderItems>
    </S.HeaderCategoryGroupRoot>
  );
};

HeaderCategoryGroup.Styled = S;
